module.exports = __webpack_public_path__ + "static/img/icon_logo.a59eeca2.png";